// eslint-disable-next-line import/prefer-default-export
export const getUser = /* GraphQL */ `
    query GetUser($id: ID!) {
        getUser(id: $id) {
            id
            username
            name {
                first
                last
            }
            ensembleIds
            instrumentIds
        }
    }
`;

export const listStudentEvents = /* GraphQL */ `
  query ListStudentEvents(
    $id: ID
    $filter: ModelStudentEventFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listStudentEvents(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        busId
        chaperoneId
        hotelId
        room
        medicalReceived
      }
      nextToken
    }
  }
`;



export const listBuses = /* GraphQL */ `
  query ListBuses(
    $id: ID
    $filter: ModelBusFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listBuses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
      }
      nextToken
    }
  }
`;

export const listChaperones = /* GraphQL */ `
  query ListChaperones(
    $id: ID
    $filter: ModelChaperoneFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listChaperones(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name {
          prefix
          first
          last
        }
      }
      nextToken
    }
  }
`;

export const listEnsembles = /* GraphQL */ `
  query ListEnsembles(
    $id: ID
    $filter: ModelEnsembleFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEnsembles(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        slug
        code
      }
      nextToken
    }
  }
`;

export const listHotels = /* GraphQL */ `
  query ListHotels(
    $id: ID
    $filter: ModelHotelFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listHotels(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
      }
      nextToken
    }
  }
`;

export const listSelections = /* GraphQL */ `
  query ListSelections(
    $id: ID
    $filter: ModelSelectionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSelections(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accepted
        application {
          id
          studentApplicationsId
        }
        selectionEnsembleId
      }
      nextToken
    }
  }
`;

export const listStudents = /* GraphQL */ `
    query ListStudents(
        $id: ID
        $filter: ModelStudentFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listStudents(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
              id
              name {
                first
                last
                preferred
              }
              sex
              gender
              phone {
                number
              }
              eventId
            }
            nextToken
        }
    }
`;
